// @ts-nocheck
import { Icon } from '@iconify/react';
import * as React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import arrowIosBackFill from '@iconify/icons-eva/arrow-ios-back-fill';
// material
import { useTheme, styled } from '@mui/material/styles';
import { Box, Paper, Stack, Card, Button, Collapse, TextField, IconButton, Typography, GridLegacy as Grid  } from '@mui/material';
import plusFill from '@iconify/icons-eva/plus-fill';
import moreVerticalFill from '@iconify/icons-eva/more-vertical-fill';

import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import LoadingButton from '@mui/lab/LoadingButton';

import { useEffect, useState } from 'react';

import Page from '../../../../../components/Page';
import LightboxModal from '../../../../../components/LightboxModal';
import { doc400 } from '../../../../userImage';
import DocPreview, { LoadingPreview } from './DocPreview';
import DocUploadDropzone from './DocUploadDropzone';
import { FDate } from 'src/constants/defaultValues';


// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
  display: 'flex',
  minHeight: '100%',
  alignItems: 'center',
  padding: theme.spacing(12, 0)
}));

// ----------------------------------------------------------------------

export default function VerifyCode({doc, isMobile, toast, editable, handleAddDoc, handleUpdateDoc,loading}) {

  const theme = useTheme();
  const isLight = theme.palette.mode === 'light';

  let [provider, setProvider] = useState('');
  let [expiryDate, setExpiryDate] = useState('');
  let [policyNumber, setPolicyNumber] = useState('');
  let [coverageAmount, setCoverageAmount] = useState('');
  let [file, setFile] = useState(null);
  let [fileId, setFileId] = useState(null);
  let   [currentFile, setCurrentFile] = useState(null);
  let   [fileOpen, setFileOpen] = useState(false);

  // let [cards, setCards] = useState([]);



  useEffect(()=>{
    if(doc && doc.id){
      if(doc.provider) setProvider(doc.provider)
      if(doc.expiry_date) setExpiryDate(doc.expiry_date)
      if(doc.policy_number) setPolicyNumber(doc.policy_number)
      if(doc.coverageAmount != null) setCoverageAmount(String(doc.coverageAmount))
    }

  },[doc]);

  // const handleSubmit = e=>{

  //   if(cards.length>0){
  //     handleLicenses(cards);
  //   }else{
  //     toast('warning', 'Please add at least one card!')
  //   }
  // }

  const handleSubmit = e=>{

    if(expiryDate){
		if(expiryDate=='Invalid Date'){
			toast('warning', 'Please select a valid expiry date');
			return;
		}
      // Insurer, policy and cover are what a reviewer checks against the
      // contract's required limits; the expiry alone told them nothing.
      let insurance = {
          provider: provider.trim() || 'Public Liability',
          policy_number: policyNumber.trim() || undefined,
          coverageAmount: coverageAmount === '' ? null : Number(coverageAmount),
          expiry_date: new Date(expiryDate).toISOString().split('T')[0],
      };
      if(fileId){
        insurance.fileId = fileId;
      }

      if(doc && doc.id){
        handleUpdateDoc(insurance);
      }else{
        if(!insurance.fileId){
          toast('warning','Please upload the copy!');
          return;
        }
        handleAddDoc(insurance);
      }


    }else{
    toast('warning', 'Please fill all the fields!')
    }
  }

  const handleViewDoc = doc=>{
    setCurrentFile(doc.file);
    setFileOpen(true);
  }

  const stackStyle = {};
  if(isMobile){
    stackStyle.maxHeight = '90vh';
    stackStyle.overflowY = 'auto';
  }

  return (
    <div style={stackStyle}>

      <Stack spacing={2} direction={{ xs: 'column', md: 'row' }}>
          <Paper
            sx={{
              p: 2,
              width: 1,
              position: 'relative',
              
            }}
            
          >

        <Grid container spacing={3} sx={{ mb: 1 }}>
          <Grid item xs={3} >
            <Box
                component="img"
                alt="icon"
                src={`/static/icons/PLI-${isLight ? 'light' : 'dark'}.png`}
                loading="lazy"
                decoding="async"
            />
          </Grid>
      
          <Grid item xs={9} >
            <Box
              component="form"
              noValidate
              autoComplete="off"
            >
             <Typography>Public Liability Insurance</Typography>
            {
                editable?(
                    <Box sx={{ mt:2 }} >
                    <Stack spacing={2} sx={{ mb: 2 }}>
                      <TextField size="small" label="Insurer" value={provider} onChange={(e)=>setProvider(e.target.value)} />
                      <TextField size="small" label="Policy number" value={policyNumber} onChange={(e)=>setPolicyNumber(e.target.value)} />
                      <TextField size="small" type="number" label="Cover amount ($)" inputProps={{ min: 0 }} value={coverageAmount} onChange={(e)=>setCoverageAmount(e.target.value)} />
                    </Stack>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker format="dd-MM-yyyy" 
                        label="Policy Expiry Date"
                        openTo="day"
                            views={['day','month','year']}
                        value={expiryDate}
                        onChange={(newValue) => {
                            setExpiryDate(newValue);
                        }}
                        />
                    </LocalizationProvider>
                    </Box>
                ):(
                    <Box>
                      {(provider || policyNumber || coverageAmount) && (
                        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                          {[provider, policyNumber && `Policy ${policyNumber}`, coverageAmount && `Cover $${Number(coverageAmount).toLocaleString()}`].filter(Boolean).join(' · ')}
                        </Typography>
                      )}
                      <Typography>Expires: <span style={{ color: '#fda92d' }}>{FDate(expiryDate)}</span></Typography>
                    </Box>
                )
            }
            </Box>
          </Grid>
        </Grid>


        {
          editable?(
            <Box sx={{ mt: 2 }}>
              <DocUploadDropzone
                label="Upload a Photo of Your Policy"
                file={file || doc?.file}
                toast={toast}
                onUploaded={(res)=>{ setFileId(res.fileId); setFile(res.url); }}
              />
            </Box>
          ):null
        }



            
          </Paper>

      </Stack>
      {
            editable?(
                <LoadingButton fullWidth variant="contained" loading={loading} disabled={!file && !doc?.file} sx={{mt:2}} onClick={handleSubmit}> {doc?.id ? 'Save changes' : 'Upload'} </LoadingButton>
            ):<DocPreview file={doc.file} />

      }


    </div>
  );
}